// Classes
window.Utils   = require('./classes/Utils.js');
window.CartItems = require('./classes/CartItems.js');

require('./ui/common.js');
require('./ui/listing.js');
require('./ui/static-forms.js');
require('./ui/swiper_init.js');
require('./ui/popup.js');
require('./ui/ajax-forms.js');
require('./ui/product-gallery.js');
require('./ui/tabs.js');
require('./ui/product.js');
require('./ui/cart.js');
require('./ui/tracking.js');
require('./ui/sharing.js');
require('./ui/web-vitals.js');

// Init classes
Popup.init();
CartItems.init();

Vue.filter("format_money", function(money) {
	let number = (typeof money === "number") ? money : +money.replace(/[^\d.,]/g, '');
	money = isNaN(number) ? 0 : number.toFixed(2);
	money = ("" + money).replace("\.", ".");

	return money;
});

// Init Vue components
Vue.component(
	'cart-products', 
	require('./components/CartProducts.vue').default
);

Vue.component(
    'product-search',
    require('./components/Search.vue').default
);

let CartProducts = null;
let SearchVue = null;
let SearchVuePopup = null;

// Instantiate component only if the element/s exists
if (document.getElementsByClassName("cart-products").length) 
{
	SearchVue = new Vue({
		el: ".header__search"
	});
}

// Instantiate component only if the element exists
if (document.getElementById("cart-products")) 
{
	CartProducts = new Vue({
		el: '#cart-products',
	});
}

Popup.on("open", function(popup) {
	if (popup == "search") {
		SearchVuePopup = new Vue({
			el: ".popup"
		});
	}
});

Popup.on("close", function(popup) {
	if (popup == "search") {
		SearchVuePopup.$destroy();
	}
});
